import { useEffect, useRef } from "react";

// Adds `.sba-visible` to an element once it enters the viewport.
export default function useReveal(options = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("sba-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, ...options }
    );

    io.observe(el);
    return () => io.disconnect();
  }, [options]);

  return ref;
}
